import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Heart, Calendar, BookOpen, Sparkles } from "lucide-react";

export default function Dashboard() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return; // callback handles it
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null))
      .finally(() => setChecking(false));
  }, []);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) {
    return <div className="max-w-4xl mx-auto px-6 py-24 text-ub-2">Loading…</div>;
  }

  if (!user) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="dashboard-login">
        <div className="font-script text-primary-ub text-4xl">Welcome</div>
        <h1 className="font-serif text-5xl mt-3">Enter the circle.</h1>
        <p className="mt-4 text-ub-2 max-w-md mx-auto">
          Join Universalbeing's community — monthly live circles, member practices, and gentle notes from Anant.
        </p>
        <button onClick={login} data-testid="dashboard-google-login" className="mt-8 bg-ub-dark text-white rounded-full px-8 py-4 hover:bg-primary-ub transition-colors">
          Continue with Google
        </button>
      </div>
    );
  }

  return (
    <div data-testid="dashboard-page" className="max-w-6xl mx-auto px-6 md:px-10 py-16 md:py-24">
      <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
        {user.picture && <img src={user.picture} alt="" className="w-20 h-20 rounded-full border border-ub" />}
        <div>
          <div className="text-sm uppercase tracking-widest text-primary-ub">Member Portal</div>
          <h1 className="font-serif text-4xl md:text-5xl mt-2">Welcome, {user.name?.split(" ")[0]}.</h1>
          <p className="text-ub-2 mt-1">{user.email}</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
        <div className="bg-ub-alt border border-ub rounded-3xl p-7">
          <Calendar className="text-primary-ub" />
          <h3 className="font-serif text-2xl mt-4">Next Live Circle</h3>
          <p className="text-ub-2 mt-2">First Saturday of each month · 10 AM IST. Watch your inbox for the link.</p>
        </div>
        <div className="bg-ub-alt border border-ub rounded-3xl p-7">
          <BookOpen className="text-primary-ub" />
          <h3 className="font-serif text-2xl mt-4">Practices</h3>
          <p className="text-ub-2 mt-2">Guided meditations & journaling prompts drop every Sunday morning.</p>
        </div>
        <div className="bg-ub-alt border border-ub rounded-3xl p-7">
          <Heart className="text-primary-ub" />
          <h3 className="font-serif text-2xl mt-4">Your Journey</h3>
          <p className="text-ub-2 mt-2">Your program registrations, bookings and notes will appear here soon.</p>
        </div>
      </div>
      <div className="mt-12 bg-ub border border-ub rounded-[2rem] p-8 md:p-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <div className="inline-flex items-center gap-2 text-primary-ub"><Sparkles size={16} /> <span className="text-sm uppercase tracking-widest">A quiet nudge</span></div>
          <h2 className="font-serif text-3xl mt-3">Not sure where to begin?</h2>
          <p className="text-ub-2 mt-1">Take the 1-minute quiz — Anant's advisor will point you home.</p>
        </div>
        <button onClick={() => navigate("/quiz")} data-testid="dashboard-quiz-cta" className="bg-primary-ub text-white rounded-full px-7 py-3.5 hover:bg-[var(--ub-primary-hover)] transition-colors">
          Take the quiz
        </button>
      </div>
    </div>
  );
}
